import { render, staticRenderFns } from "./maker.vue?vue&type=template&id=2890d619"
import script from "./maker.vue?vue&type=script&lang=js"
export * from "./maker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports